<script>

export default {
  name: 'Cars',

  computed: {
    slides () {
      let slides = [
        this.$t(`cars.slide_1${this.vehicleString('', '_bike')}`),
        this.$t('cars.slide_2'),
        Object.defineProperty(this.$t('cars.slide_3'), 'cars_type', {
          value : {
            electric: this.fuelTypeIs('electric'),
            petrol: this.fuelTypeIs('petrol')
          },
          enumerable: true,
          configurable: true,
          writable: true})
      ]

      if (!this.isFreeForAll) {
        slides.push(this.$t('cars.slide_4'))
      }

      return slides
    },

    providerLogo () {
      if (this.teamsiteConfig && this.teamsiteConfig.provider && this.teamsiteConfig.provider.image) {
        return this.teamsiteConfig.provider.image.url
      }
    },

    onlyElectric () {
      return this.fuelTypeIs('electric') && !this.fuelTypeIs('petrol')
    },

    petrolAndElectric () {
      return this.fuelTypeIs('electric') && this.fuelTypeIs('petrol')
    },

    selectedTeamId() {
      if (this.teamIdForSignup) { return this.teamIdForSignup }

      if (this.teamsiteConfig.car_sections.length > 0) {
        return this.teamsiteConfig.car_sections[0].team_id
      }

      return this.teamsiteConfig.id
    }
  },

  mounted() {
    this.$bus.$on('set:team-cars', (cars) => {
      this.$set(this.teamsiteConfig, 'cars', cars)
    })
  },

  methods: {
    fuelTypeIs (type) {
      const allCarsAsString = JSON.stringify(this.teamsiteConfig.cars)

      if (type === 'petrol') {
        let fuelTypes = ['super_petrol', 'diesel', 'natural_gas', 'liquid_gas', 'bio_gas', 'hybrid_electric_petrol', 'hybrid_electric_diesel', 'hydrogen', 'other_fuel']

        return fuelTypes.some(v => {
          return allCarsAsString.indexOf('"fuel_type":"' + v + '"') > -1
        })
      } else if (type === 'electric') {
        return allCarsAsString.indexOf('"fuel_type":"electric"') > -1
      }
      return allCarsAsString.indexOf('"fuel_type":"' + type + '"') > -1
    },

  }
}
</script>

<template>
  <div class="cars" v-if="teamsiteConfig">

    <admin-edit title="Tarife bearbeiten" :url="`/pl/0/platform_admin/team_site_configurations/${selectedTeamId}/edit`"></admin-edit>

    <car-sections v-if="teamsiteConfig.car_sections && teamsiteConfig.car_sections.length > 0" :car-sections="teamsiteConfig.car_sections"></car-sections>
    <car-list v-else-if="teamsiteConfig.cars" :cars="teamsiteConfig.cars"></car-list>

    <divider :size="10"/>
    <br><br><br>

    <div v-if="teamsiteConfig.cars">

      <admin-edit title="Texte bearbeiten" :url="`/pl/0/platform_admin/team_site_configurations/${teamsiteConfig.id}/edit#team_site_configuration_parking_description_input`"></admin-edit>

      <content-swiper :slides="slides">

        <template slot="slide-0" slot-scope="props">
          <slide :slide="props.slide">
            <template slot="image" slot-scope="_">
              <div class="columns medium-18 medium-offset-3 text-center hide-for-small-only">
                <div v-if="teamsiteConfig.parking_description">
                  <br/><br/>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100" height="100" style="width: 180px; height: 180px;"><path :fill="teamsiteConfig.color" d="M50.67 11.74c-13.81 0-25 11.19-25 25 0 5.63 1.86 10.83 5.01 15.01.05.13.11.25.19.37l18.7 28.21c.61.92 1.6.92 2.21 0l18.57-28.02c.09-.13.15-.27.21-.42 3.21-4.2 5.12-9.45 5.12-15.15-.01-13.8-11.21-25-25.01-25zm0 40c-8.28 0-15-6.72-15-15 0-8.28 6.72-15 15-15 8.28 0 15 6.72 15 15 0 8.29-6.72 15-15 15z"></path></svg>
                </div>

                <br/><br/>
                <img v-if="providerLogo" :src="providerLogo"/>
              </div>
            </template>

            <template slot="content" slot-scope="_">
              <div v-if="teamsiteConfig.parking_description">
                <h2 v-html="$t(`cars.slide_1${vehicleString('', '_bike')}.location`)"></h2>
                <p class="user-generated" v-html="teamsiteConfig.parking_description"></p>
              </div>

              <div v-if="teamsiteConfig.provider_description">
                <h2 v-html="$t(`cars.slide_1${vehicleString('', '_bike')}.provider`)"></h2>
                <p class="user-generated" v-html="teamsiteConfig.provider_description"></p>
              </div>
            </template>
          </slide>
        </template>


        <template slot="slide-1" slot-scope="props">
          <slide :slide="props.slide">
            <template slot="image" slot-scope="_">

              <div class="hide-for-small-only">
              </div>

            </template>

            <template slot="content" slot-scope="_">
              <h2>{{ props.slide.title }}</h2>
              <p class="user-generated" v-html="teamsiteConfig.insurance_description"></p>
            </template>
          </slide>
        </template>

        <template slot="slide-2" slot-scope="props">
          <slide :slide="props.slide">
            <template slot="image" slot-scope="_">

              <div class="hide-for-small-only">
              </div>

            </template>

            <template slot="content" slot-scope="_">
              <h2 v-if="onlyElectric">{{ props.slide.title_electric }}</h2>
              <h2 v-else-if="petrolAndElectric">{{ props.slide.title_petrol_and_electric }}</h2>
              <h2 v-else>{{ props.slide.title }}</h2>
              <p class="user-generated" v-html="teamsiteConfig.fueling_description"></p>

            </template>
          </slide>
        </template>

        <template slot="slide-3" slot-scope="props">
          <slide :slide="props.slide">
            <template slot="image" slot-scope="_">

              <div class="hide-for-small-only">
              </div>

            </template>

            <template slot="content" slot-scope="_">
              <h2>{{ props.slide.title }}</h2>
              <p class="user-generated" v-html="teamsiteConfig.how_to_pay"></p>

            </template>
          </slide>
        </template>


      </content-swiper>
    </div>

    <legal-documents></legal-documents>

    <divider :size="10"/>
    <giant-cta></giant-cta>
  </div>
</template>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Cars.vue